import React, { useState, useEffect } from "react";
import axios from "axios";
import BlogCard from "./BlogCard";
import InfiniteScroll from "react-infinite-scroll-component";
const API_HOST = process.env.REACT_APP_API_URL;

const BlogsList = (props) => {
  const authToken = sessionStorage.getItem("authToken");
  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const PAGE_SIZE = 25;

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    if (isLoading || !hasMore) return;

    try {
      setIsLoading(true);
      
      // Get current user's name to filter by creator
      const userResponse = await axios.post(
        `${API_HOST}auth/getuser`,
        {},
        {
          headers: { "auth-token": authToken },
        }
      );
      
      const creatorName = userResponse.data.name;
      
      // Fetch blogs filtered by creator
      const response = await axios.get(
        `${API_HOST}blogs/showAdminBlogs?page=${page}&limit=${PAGE_SIZE}&creator=${encodeURIComponent(creatorName)}`,
        {
          headers: { "auth-token": authToken },
        }
      );

      if (response.data.blogs && response.data.blogs.length > 0) {
        // Use Set to efficiently remove duplicates
        const existingIds = new Set(blogs.map(blog => blog._id));
        const newBlogs = response.data.blogs.filter(blog => !existingIds.has(blog._id));
        
        setBlogs(prevBlogs => [...prevBlogs, ...newBlogs]);
        
        // Update hasMore based on whether we received a full page of results
        // or if the API explicitly tells us there are more results
        const receivedFullPage = response.data.blogs.length === PAGE_SIZE;
        setHasMore(receivedFullPage || response.data.hasMore);
        
        setPage(prevPage => prevPage + 1);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
      // Don't set hasMore to false on error, as it might be a temporary issue
    } finally {
      setIsLoading(false);
    }
  };

  // Function to manually trigger loading more if needed
  const loadMore = () => {
    if (!isLoading && hasMore) {
      fetchBlogs();
    }
  };

  return (
    <InfiniteScroll
      dataLength={blogs.length}
      next={fetchBlogs}
      hasMore={hasMore}
      loader={
        <p className="text-center text-gray-500 mt-4">
          {isLoading ? "Loading more..." : ""}
        </p>
      }
      endMessage={
        <p className="text-center text-gray-500 mt-4">
          {blogs.length === 0 ? "No blogs available." : "No more blogs available."}
        </p>
      }
      scrollThreshold="80%"
    >
      <div className="space-y-4">
        {blogs.map((blog) => (
          <BlogCard 
            setBlogId={props.setBlogId} 
            content={blog} 
            key={blog._id} 
          />
        ))}
      </div>
      {hasMore && !isLoading && (
        <div className="text-center mt-4">
          <button 
            onClick={loadMore}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Load More
          </button>
        </div>
      )}
    </InfiniteScroll>
  );
};

export default BlogsList;
